export class ParentGridModel {
    ordered: string
    item_code: string
    item_desc: string
    order_amount: number
    container_type: string
    container_cost: number
    qty_on_hand: number
    method_of_issue: string
    vendor: string
    vendor_code: string
    vendor_name: string
    contact: string
    fax_no: string
    email_address: string
    item_no: number
    item_type: number
    no: number
    item_clinic: number
    order_no: number
    reorder_point: number
    max_stock_level: number
    code_fix: string
    unit_per_issue: number
    unit_per_container: number
    issue_container: string
    vendor_message: string
    po_no: string
    order_date: string
    special_msg: string
    order_code: string
    select: boolean
    edit_order_amount: boolean
    edit_vendor: boolean
    edit_container_cost: boolean
    manufacturer_code: string

    private _subtotal: number
    _default: boolean
    order_item_active: boolean
    order_item_modified_date: string

    public get subtotal(): number {
        return this.order_amount * this.container_cost;
    }

    public set subtotal(subtotal: number) {
        this._subtotal = subtotal;
    }

    private _options: string

    public get options(): string {
        return `${this.vendor_code} : ${this.unit_per_issue} ${this.method_of_issue} / ${this.issue_container} -- ${this.unit_per_container} / ${this.container_type}`;
    }

    public set options(options: string) {
        this._options = options;
    }

    constructor(
        ordered: string,
        item_code: string,
        item_desc: string,
        order_amount: number,
        container_type: string,
        container_cost: number,
        qty_on_hand: number,
        method_of_issue: string,
        vendor: string,
        vendor_code: string,
        vendor_name: string,
        contact: string,
        fax_no: string,
        email_address: string,
        item_no: number,
        item_type: number,
        no: number,
        item_clinic: number,
        order_no: number,
        reorder_point: number,
        max_stock_level: number,
        code_fix: string,
        unit_per_issue: number,
        unit_per_container: number,
        issue_container: string,
        vendor_message: string,
        po_no: string,
        order_date: string,
        special_msg: string,
        order_code: string,
        _default: boolean,
        order_item_active: boolean,
        order_item_modified_date: string,
        manufacturer_code: string
    ) {
        this.ordered = ordered
        this.item_code = item_code
        this.item_desc = item_desc
        this.order_amount = order_amount
        this.container_type = container_type
        this.container_cost = container_cost
        this.qty_on_hand = qty_on_hand
        this.method_of_issue = method_of_issue
        this.vendor = vendor
        this.vendor_code = vendor_code
        this.vendor_name = vendor_name
        this.contact = contact
        this.fax_no = fax_no
        this.email_address = email_address
        this.item_no = item_no
        this.item_type = item_type
        this.no = no
        this.item_clinic = item_clinic
        this.order_no = order_no
        this.reorder_point = reorder_point
        this.max_stock_level = max_stock_level
        this.code_fix = code_fix
        this.unit_per_issue = unit_per_issue
        this.unit_per_container = unit_per_container
        this.issue_container = issue_container
        this.vendor_message = vendor_message
        this.po_no = po_no
        this.order_date = order_date
        this.special_msg = special_msg
        this.order_code = order_code
        this.select = false;
        this.edit_order_amount = false;
        this.edit_vendor = false;
        this.edit_container_cost = false;
        this._default = _default;
        this.order_item_active = order_item_active;
        this.order_item_modified_date = order_item_modified_date;
        this.manufacturer_code = manufacturer_code;
    }
}